
import BaseCard from '../base-card/base-card';

export default class TeaserCard extends BaseCard {
  constructor(container) {
    super(container);
    this.selector = '.teaser-card';
  }
}
